import { useState } from 'react';
import { useContext } from 'v2/hooks/context';
import { goTo } from 'v2/helpers/url';

const useAddProject = (
  dispatch,
  projectData = {},
  asiteFolderData = null,
  hasAsiteFoldersFeature = false,
  hasIfsFeature = false,
  ifsProjectData = null,
) => {
  const [projectName, setProjectName] = useState(projectData?.name || '');
  const [projectReference, setProjectReference] = useState(
    projectData?.reference || '',
  );
  const [description, setDescription] = useState(
    projectData?.description || '',
  );
  const [region, setRegion] = useState(projectData?.region || '');
  const [type, setType] = useState(projectData?.type || '');
  const [Group, setGroup] = useState(projectData?.group || '');

  const [errors, setErrors] = useState([]);

  const context = useContext('clink');
  const { actions } = context;

  const resetForm = () => {
    setProjectName('');
    setProjectReference('');
    setDescription('');
    setRegion('');
    setType('');
    setGroup('');
    setErrors([]);
  };

  const handleAddProject = async () => {
    const missingFields = [];
    const catalogueId = Number(ifsProjectData?.id) || 0;

    if (hasAsiteFoldersFeature && !asiteFolderData) {
      missingFields.push('asite-folder-error');
    }

    if (hasIfsFeature && catalogueId <= 0) {
      missingFields.push('ifs-project-error');
    }

    if (!projectName.trim()) {
      missingFields.push('project-name-error');
    }

    if (!projectReference.trim()) missingFields.push('project-reference-error');
    if (!region.trim()) missingFields.push('location-error');
    if (!type.trim()) missingFields.push('type-error');
    if (!Group.trim()) missingFields.push('group-error');

    setErrors(missingFields);
    if (missingFields.length) {
      return;
    }
    const projectPayload = {
      region,
      reference: projectReference,
      name: projectName,
      type,
      account_group_id: [Number.parseInt(Group, 10)],
    };

    if (hasAsiteFoldersFeature && asiteFolderData) {
      projectPayload.integration_id = asiteFolderData.id;
      projectPayload.integration_name = asiteFolderData.name;
      projectPayload.integration_uri = asiteFolderData.uri;
    }

    if (hasIfsFeature && catalogueId > 0) {
      projectPayload.partner_project_catalogue_id = catalogueId;
    }

    const result = await dispatch(actions.addProject(projectPayload));
    if (result?.error) {
      setErrors([`${result?.error?.message || 'Error'} - ${result?.payload}`]);
      return;
    }
    const slug = projectName
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    goTo(`/projects/${slug}/setup`);
  };

  return {
    useProjectName: [projectName, setProjectName],
    useProjectReference: [projectReference, setProjectReference],
    useDescription: [description, setDescription],
    useLocation: [region, setRegion],
    useType: [type, setType],
    useGroup: [Group, setGroup],
    useErrors: [errors, setErrors],
    handleAddProject,
    resetForm,
  };
};

export default useAddProject;
